import { NullTemplateVisitor } from "@angular/compiler";
import { BaseEntity } from "yt-ng-framework";

export class Roba extends BaseEntity{
    constructor(){
        super();
    };

    Sifra:string = null;
    Barcode:string = null;
    Naziv:string = null;
    RobnaGrupaID:number = null;
    UnitOfMeasureID:number = null;
    AltUnitOfMeasureID:number = null;
    JmOdnos:number = null;
    TarifaID:number = null;
    Usluga:boolean = false;
    Sirovina:boolean = false;
    Poluproizvod:boolean = false;
    GotovProizvod:boolean = false;
    PomocniMaterijal:boolean = false;
    Ambalaza:boolean = false;
    TrgovackaRoba:boolean = false;
    SitanInventar:boolean = false;
    ProizvodjacID:number = null;
    DrzavaPoreklaID:number = null;
    RokTrajanjaUDanima:number = null;
    KolicinaZaPakovanje:number = null;
    RedosledUListi:number = null;
    TezinskiBarcode:string = null;
    Napomena:string = null;
    AkciznaRobaID:number=null;
    RobaID:number=null;
    OpasnaMaterija:boolean=false;
    AkciznaRobaSifraRobneMarke:string = null;

    Deserialize(input:any){
        this.ID = input.ID;
        this.Sifra=input.Sifra;
        this.Barcode=input.Barcode;
        this.Naziv=input.Naziv;
        this.RobnaGrupaID=input.RobnaGrupaID;
        this.UnitOfMeasureID=input.UnitOfMeasureID;
        this.AltUnitOfMeasureID=input.AltUnitOfMeasureID;
        this.JmOdnos=input.JmOdnos;
        this.TarifaID=input.TarifaID;
        this.Usluga=input.Usluga;
        this.Sirovina=input.Sirovina;
        this.Poluproizvod=input.Poluproizvod;
        this.GotovProizvod=input.GotovProizvod;
        this.PomocniMaterijal=input.PomocniMaterijal;
        this.Ambalaza=input.Ambalaza;
        this.TrgovackaRoba=input.TrgovackaRoba;
        this.SitanInventar=input.SitanInventar;
        this.ProizvodjacID=input.ProizvodjacID;
        this.DrzavaPoreklaID=input.DrzavaPoreklaID;
        this.RokTrajanjaUDanima=input.RokTrajanjaUDanima;
        this.KolicinaZaPakovanje=input.KolicinaZaPakovanje;
        this.RedosledUListi=input.RedosledUListi;
        this.TezinskiBarcode=input.TezinskiBarcode;
        this.Napomena=input.Napomena;
        this.AkciznaRobaID=input.AkciznaRobaID;
        this.OpasnaMaterija=input.OpasnaMaterija;
        this.AkciznaRobaSifraRobneMarke=input.AkciznaRobaSifraRobneMarke;
        // this.RobaID=input.RobaID;
        return this;
    }

    Serialize(input:Roba){
        return input;
    }

}